
import '../../Pages/Client/AO/AODetails.scss';
import '../../Pages/Client/AO/Alertes.scss';

//import { ROLES } from './config';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, createTheme, Dialog, IconButton, Toolbar } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

import { ROLES } from '../../config';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useFormValidation from '../../hooks/useFormValidation';
import usePostRequest from '../../hooks/usePostRequest';
import useRole from '../../hooks/useRole';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { requiredColorCode } from '../../Styles/componentStyles';
import { isHttpStatusSuccess, roleCollab } from '../../Utils/utils';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import { TextFieldComponent, Transition } from '../shared/ReusableSmallComponents';

{/*mode==ajouter c pour ajouter un collaborateur*/ }
{/*mode==editer c pour editer les roles d'un collaborateur*/ }
function DialogValiderCollab({ open, setOpen, rowSelected, title, mode, getMyCollaborators }) {
    DialogValiderCollab.propTypes = {
        open: PropTypes.any,
        rowSelected: PropTypes.any,
        setOpen: PropTypes.func,
        getMyCollaborators: PropTypes.func,
        mode: PropTypes.any,
        title: PropTypes.any,
    };
    const { setShowErrors, setErrors, showErrors } = useUtilities();
    const axiosPrivate = useAxiosPrivate();
    const { postData } = usePostRequest();
    const [email, setEmail] = useState('');
    const [nom, setNom] = useState('');
    const location=useLocation();
    const [prenom, setPrenom] = useState('');
    const [tele, setTele] = useState('');
    const { device } = useWindowSize();
    const role=useRole();
    const rolesInitialState = role === 'client'
        ? { isLittleAdmin: '', isManager: '', isResponsableAchat: '', isRh: '', isComptable: '' }
        : (role === 'esn' ? { isLittleAdmin: '', isCommercial: '', isComptable: '', isSignataire:'' } :{ isLittleAdmin: '', isCommercial: '', isComptable: '' });

    const [roles, setRoles] = useState(rolesInitialState);
    // const [roles, setRoles] = useState({ isLittleAdmin: '', isManager: '', isResponsableAchat: '', isRh: '', isComptable: '', });
    const { i18n } = useTranslation();
    const [isValid] = useFormValidation([
        { name: 'nom', value: nom },
        { name: 'prenom', value: prenom },
        { name: 'email', value: email },
    ]);

    const hasSelectedRole = useMemo(() => Object.values(roles).some(val => {
        if (typeof val === 'boolean') {
            return val === true;
        }
        return val.trim() !== '';
    }), [roles]);

    useEffect(() => {
        if (rowSelected) {
            console.log('rowSelected hey', rowSelected);
            setEmail(rowSelected?.email_);
            setNom(rowSelected?.nom);
            setPrenom(rowSelected?.prenom);
            setTele(rowSelected?.tele);
            //console.log('rowselecte', rowSelected);
            if(role=='esn' || location.pathname.includes('gestionEsn'))
                setRoles({
                    isAdmin: roleCollab(rowSelected?.role?.Admin),
                    isLittleAdmin: roleCollab(rowSelected?.role?.littleAdmin),
                    isCommercial: roleCollab(rowSelected?.role?.Commercial),
                    isComptable: roleCollab(rowSelected?.role?.Comptable),
                    isSignataire: (rowSelected?.signataire ||roleCollab(rowSelected?.role?.signataire))
                });
            else
                setRoles({
                    isAdmin: roleCollab(rowSelected?.role?.Admin),
                    isLittleAdmin: roleCollab(rowSelected?.role?.littleAdmin),
                    isManager: roleCollab(rowSelected?.role?.Manager),
                    isResponsableAchat: roleCollab(rowSelected?.role?.ResponsableAchat),
                    isRh: roleCollab(rowSelected?.role?.Rh),
                    isComptable: roleCollab(rowSelected?.role?.Comptable),
                });
        }
    }, [rowSelected]);

    const updateCollabStatus = async () => {
        var nombreRoleAffectees = Object.values(roles).filter(object => object == 1).length;
        if (nombreRoleAffectees >= 1) {
            try {
                const response = await axiosPrivate.post(
                    `/${role}/acceptInvitation`, // use useRole to select the role, bcs it could be esn and not /client
                    {
                        colaboratorEmail: rowSelected?.email_ ?? email,
                        roles: roles, // todo: 4esn : isCommercial , isComptable, isLittleAdmin
                        nom, prenom, tele,
                    });
                if (isHttpStatusSuccess(response?.status)) {
                    // handleClose();
                    console.log('success');
                    getMyCollaborators();
                    handleClose();

                }
                //Swal.fire('accepted! role changed',
                //    JSON.stringify(response.data.message),
                //    'success');
                // Swal.fire({ text: response.data.message })
            } catch (error) {
                console.log(error);
                console.log(error.response.data?.error);
                //Swal.fire('error occured', JSON.stringify(error.response.data?.error), 'error');
                // Swal.fire({ text: error.response.data?.error })
            }
        }
        else {
            Swal.fire('error occured', 'Il faut au minimum garder un seul rôle affecté !', 'error');
        }
    };

    //useEffect(() => {
    //    if (rowSelected) {
    //        console.log('rowSelected dialog valider colab',rowSelected);
    //    }
    //}, [rowSelected]);

    //console.log('get element table',getMyCollaborators());

    const enovoyerInv = async () => {
        try {
            const response = await postData({
                url: `${role}/inviteCollaboratorByClientOwner`, payload: {
                    role: role !== 'esn' ? ROLES.Client : ROLES.Esn,
                    email, nom, prenom, tele,
                }
            });
            console.log(response.data);
            if (isHttpStatusSuccess(response.responseStatus)) {
                console.log('added');
            }
        } catch (error) {
            console.log(error);
        }
    };
    const handleClose = () => {
        setOpen(false);
        setEmail('');
        setNom('');
        setPrenom('');
        setTele('');
        setRoles(role=='client'?{ isLittleAdmin: '', isManager: '', isResponsableAchat: '', isRh: '', isComptable: '', }
            :{ isLittleAdmin: '', isCommercial: '', isComptable: '' });
        //setOpen();
        // getMyCollaborators(); //* we can think about doint getMyCollaborators here
    };
    const scroll = 'paper';
    const theme = createTheme({
        overrides: {
            MuiAppBar: {
                root: {
                    borderRadius: '20px', // Set the desired borderRadius value here
                },
            },
        },
    });

    return (
        <Dialog
            fullScreen
            open={open}
            TransitionComponent={Transition}
            onClose={handleClose}
            scroll={scroll}
            PaperProps={{
                style: {
                    background: '#F5F6FA',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <ThemeProvider theme={theme}>
                <AppBar>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', background: '#F5F6FA', paddingTop: '90px', paddingBottom: '24px', paddingLeft: device == 'desktop' ? '24px' : '0px' }}>
                    <div className='frame0FicheCollab'>
                        <h4 className='frame1FicheCollab'>{i18n.t(title)}</h4>
                        {mode != 'ajouter' &&
                            <div className='frame2FicheCollab'>
                                <div className='frame3FicheCollab'>
                                    <img
                                        src={rowSelected?.img}
                                        style={{ width: '100px', height: '100px', borderRadius: '20px' }}
                                    />
                                </div>
                                <div className='frame4FicheCollab'>
                                    <div className='frame5FicheCollab'>
                                        <h5 className='frame6FicheCollab'>{nom + ' ' + prenom}</h5>
                                        <b className='frame7FicheCollab'>{rowSelected?.email_}</b>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className='frame8FicheCollab'>
                            <div className='frame9FicheCollab'>
                                <div className='frame10FicheCollab'>
                                    <div className='frame11FicheCollab'>
                                        <TextFieldComponent
                                            id="outlined-name"
                                            label={i18n.t('Prénom')}
                                            name='prenom'
                                            value={prenom}
                                            onChange={(e) => setPrenom(e.target.value)}
                                            // disabled={mode == 'ajouter' ? false : true}
                                            style={{ width: '100%', backgroundColor: 'white' }}
                                            sx={{
                                                '& > :not(style)': { borderRadius: '8px' },
                                            }}
                                        />
                                    </div>
                                    <div className='frame12FicheCollab'>
                                        <TextFieldComponent
                                            id="outlined-name"
                                            label={i18n.t('Nom')}
                                            name='nom'
                                            value={nom}
                                            onChange={(e) => setNom(e.target.value)}
                                            // disabled={mode == 'ajouter' ? false : true}
                                            style={{ width: '100%', backgroundColor: 'white' }}
                                            sx={{
                                                '& > :not(style)': { borderRadius: '8px' },
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='frame10FicheCollab'>
                                    <div className='frame11FicheCollab'>
                                        <TextFieldComponent
                                            id="outlined-name"
                                            name='email'
                                            label={i18n.t('E-mail')}
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            disabled={mode == 'ajouter' ? false : true}
                                            style={{ width: '100%', backgroundColor: 'white' }}
                                            sx={{
                                                '& > :not(style)': { borderRadius: '8px' },
                                            }}
                                        />
                                    </div>
                                    <div className='frame12FicheCollab'>
                                        <TextFieldComponent
                                            id="outlined-name"
                                            label={i18n.t('Téléphone')}
                                            value={tele}
                                            onChange={(e) => setTele(e.target.value)}
                                            // disabled={mode == 'ajouter' ? false : true}
                                            style={{ width: '100%', backgroundColor: 'white' }}
                                            sx={{
                                                '& > :not(style)': { borderRadius: '8px' },
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='frame14FicheCollab'>
                                    <h6 className='frame15FicheCollab'>
                                        {i18n.t('Le collaborateur a comme rôle:')}
                                    </h6>
                                    {!hasSelectedRole && showErrors &&
                                        <p
                                            className='frame15FicheCollab'
                                            style={{ color: requiredColorCode }}
                                        >{i18n.t('vous devez au moins sélectionner un rôle')}</p>
                                    }
                                    <div className='frame19FicheCollab'>
                                        <div className='frame17FicheCollab'>
                                            <div className='frame29DonneeFacturation'>
                                                <input
                                                    type='checkbox'
                                                    style={{
                                                        width: '24px',
                                                        height: '24px',
                                                        borderRadius: '8px'
                                                    }}
                                                    //{...labelcheckbox}
                                                    checked={(roles?.isLittleAdmin || roles?.isAdmin) ? true : false}
                                                    value={roles?.isLittleAdmin}
                                                    onChange={(e) => {
                                                        setRoles({ ...roles, isLittleAdmin: e.target.checked });
                                                    }}
                                                    disabled={((mode == 'editer' && roles?.isAdmin == 0) || mode == 'ajouter') ? false : true}
                                                />
                                            </div>
                                            <b className='frame30DonneeFacturation'>{i18n.t('Admin')}</b>
                                        </div>
                                        <div className='frame18FicheCollab'>
                                            <div className='frame29DonneeFacturation'>
                                                <input
                                                    type='checkbox'
                                                    style={{
                                                        width: '24px',
                                                        height: '24px',
                                                        borderRadius: '8px'
                                                    }}
                                                    checked={roles['isComptable']}
                                                    onChange={(e) => {
                                                        //console.log('e.target.checked', e.target.checked);
                                                        setRoles({ ...roles, isComptable: e.target.checked });
                                                    }}
                                                    disabled={(mode == 'editer' || mode == 'ajouter') ? false : true}
                                                />
                                            </div>
                                            <b className='frame30DonneeFacturation'>{i18n.t('Comptable')}</b>
                                        </div>
                                    </div>
                                    {(role!='esn' && !location.pathname.includes('gestionEsn')) &&
                                    <div className='frame19FicheCollab'>
                                        <div className='frame17FicheCollab'>
                                            <div className='frame29DonneeFacturation'>
                                                <input
                                                    type='checkbox'
                                                    style={{
                                                        width: '24px',
                                                        height: '24px',
                                                        borderRadius: '8px'
                                                    }}
                                                    checked={roles?.isManager}
                                                    onChange={(e) => {
                                                        setRoles({ ...roles, isManager: e.target.checked });
                                                    }}
                                                    disabled={(mode == 'editer' || mode == 'ajouter') ? false : true}
                                                />
                                            </div>
                                            <b className='frame30DonneeFacturation'>{i18n.t('Responsable opérationnel')}</b>
                                        </div>
                                        <div className='frame18FicheCollab'>
                                            <div className='frame29DonneeFacturation'>
                                                <input
                                                    type='checkbox'
                                                    style={{
                                                        width: '24px',
                                                        height: '24px',
                                                        borderRadius: '8px'
                                                    }}
                                                    checked={roles?.isRh}
                                                    onChange={(e) => {
                                                        setRoles({ ...roles, isRh: e.target.checked });
                                                    }}
                                                    disabled={(mode == 'editer' || mode == 'ajouter') ? false : true}
                                                />
                                            </div>
                                            <b className='frame30DonneeFacturation'>{i18n.t('RH')}</b>
                                        </div>
                                    </div>
                                    }
                                    <div className='frame19FicheCollab'>
                                        <div className='frame17FicheCollab'>
                                            <div className='frame29DonneeFacturation'>
                                                <input
                                                    type='checkbox'
                                                    style={{
                                                        width: '24px',
                                                        height: '24px',
                                                        borderRadius: '8px'
                                                    }}
                                                    checked={(role!='esn' && !location.pathname.includes('gestionEsn'))? roles?.isResponsableAchat:roles?.isCommercial }
                                                    value={(role!='esn' && !location.pathname.includes('gestionEsn'))? roles?.isResponsableAchat:roles?.isCommercial}
                                                    onChange={(e) => {
                                                        if((role!='esn' && !location.pathname.includes('gestionEsn')))
                                                            setRoles({ ...roles, isResponsableAchat: e.target.checked });
                                                        else
                                                            setRoles({ ...roles, isCommercial: e.target.checked });
                                                    }}
                                                    disabled={(mode == 'editer' || mode == 'ajouter') ? false : true}
                                                />
                                            </div>
                                            <b className='frame30DonneeFacturation'>{(role!='esn' && !location.pathname.includes('gestionEsn')) ? i18n.t('Responsable achat'):i18n.t('Commercial') }</b>
                                        </div>
                                    </div>
                                    {(role=='esn' || location.pathname.includes('gestionEsn')) &&
                                    <div className='frame19FicheCollab'>
                                        <div className='frame17FicheCollab'>
                                            <div className='frame29DonneeFacturation'>
                                                <input
                                                    type='checkbox'
                                                    style={{
                                                        width: '24px',
                                                        height: '24px',
                                                        borderRadius: '8px'
                                                    }}
                                                    checked={roles?.isCommercial }
                                                    value={roles?.isSignataire}
                                                    onChange={(e) => {
                                                        setRoles({ ...roles, isSignataire: e.target.checked });
                                                    }}
                                                    disabled={(mode == 'editer' || mode == 'ajouter') ? false : true}
                                                />
                                            </div>
                                            <b className='frame30DonneeFacturation'>{i18n.t('Signataire')}</b>
                                        </div>
                                    </div>
                                    }
                                </div>
                                {mode == 'editer' &&
                                    <div style={{ display: 'flex', flexDirection: device == 'desktop' ? 'row' : 'column', gap: '24px', justifyContent: 'flex-end', alignSelf: 'stretch', width: '100%' }}>
                                        <Button
                                            variant='text'
                                            style={{ ...buttonStyles(), ...{ width: device == 'desktop' ? 'auto' : '100%', order: device == 'desktop' ? '0' : '1' } }}
                                            onClick={handleClose}
                                        >
                                            {i18n.t('Annuler')}
                                        </Button>
                                        <Button
                                            variant='contained'
                                            style={{ ...buttonStylesGreen(false), ...{ width: device == 'desktop' ? 'auto' : '100%', order: device == 'desktop' ? '1' : '0' } }}
                                            onClick={() => {
                                                updateCollabStatus();
                                            }}
                                        >
                                            {i18n.t('Enregistrer')}
                                        </Button>
                                    </div>
                                }
                                {mode == 'ajouter' &&
                                    <div style={{ display: 'flex', flexDirection: device == 'desktop' ? 'row' : 'column', gap: '24px', justifyContent: 'flex-end', alignSelf: 'stretch', width: '100%' }}>
                                        <Button
                                            variant='text'
                                            style={{ ...buttonStyles(), ...{ width: device == 'desktop' ? 'auto' : '100%', order: device == 'desktop' ? '0' : '1' } }}
                                            onClick={handleClose}
                                        >
                                            {i18n.t('Annuler')}
                                        </Button>
                                        <Button
                                            variant='contained'
                                            style={{ ...buttonStylesGreen(false), ...{ width: device == 'desktop' ? 'auto' : '100%', order: device == 'desktop' ? '1' : '0' } }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (isValid && hasSelectedRole) {
                                                    enovoyerInv().then(() => {
                                                        updateCollabStatus();
                                                    });
                                                    setShowErrors(false);
                                                    setErrors({});
                                                }
                                                else setShowErrors(true);
                                            }}
                                        >
                                            {i18n.t('Ajouter')}
                                        </Button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </ThemeProvider>
        </Dialog>
    );
}

export default DialogValiderCollab;